import { useEffect, useState } from "react";
import AdminLayout from "layouts/AdminLayout";
import AdminCard from "components/admin/AdminCard";
import CustomTable, { ColumnConfig } from "components/CustomTable";
import Pagination from "components/Pagination";
import { Input } from "components/ui/input";
import { listAdminLogs } from "services/admin/adminLogs.service";

type Row = { usuario: string; acao: string; cliente: string; data: string };

const columns: ColumnConfig<Row>[] = [
  { key: "usuario", header: "Usuário" },
  { key: "acao", header: "Ação" },
  { key: "cliente", header: "Cliente" },
  { key: "data", header: "Data" },
];

const AdminLogs = () => {
  const [logs, setLogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [action, setAction] = useState("");

  useEffect(() => {
    setLoading(true);
    listAdminLogs({ page, limit: 50, action })
      .then((resp) => {
        setLogs(resp.data);
        setTotalPages(resp.pagination.totalPages || 1);
      })
      .catch((err) => console.error("[AdminLogs] erro:", err))
      .finally(() => setLoading(false));
  }, [page, action]);

  const rows: Row[] = logs.map((l) => ({
    usuario: l.adminUser?.name || "Sistema",
    acao: l.action,
    cliente: l.cliente?.razaoSocial || "—",
    data: new Date(l.createdAt).toLocaleString("pt-BR"),
  }));

  return (
    <AdminLayout title="Logs" subtitle="Todas as ações do sistema">
      <div className="flex flex-col gap-4">
        <AdminCard noPadding className="p-4">
          <Input
            placeholder="Filtrar por ação (ex: client.status_change)"
            value={action}
            onChange={(e) => { setPage(1); setAction(e.target.value); }}
            className="max-w-sm"
          />
        </AdminCard>
        <AdminCard noPadding className="p-4">
          {loading ? (
            <p className="text-sm text-muted-foreground">Carregando...</p>
          ) : (
            <>
              <CustomTable objectList={rows} columns={columns} />
              <Pagination page={page} totalPages={totalPages} onChange={setPage} />
            </>
          )}
        </AdminCard>
      </div>
    </AdminLayout>
  );
};

export default AdminLogs;
